import {Injectable} from '@angular/core';
import {StammdatenNatuerlichePerson, Steueridentifikation} from '@nachdigal';
import {AbstractMapper} from '../../abstract.mapper';

@Injectable()
export class SteueridentifikationMapperService extends AbstractMapper<StammdatenNatuerlichePerson, Steueridentifikation> {

  protected mapInternal(source: StammdatenNatuerlichePerson): Steueridentifikation {

    return {
      steueridentifikationsnummer: source.identifikationsnummer
    };
  }
}
